import { useTranslation } from 'react-i18next';
import { StyledDivButton, SubmitButton } from '../StyledComponents';
import FileInput from '../../../../shared/FileInput';
import { useUserUploadForm } from '../../../campaigns/components/UserUpload/useUserUploadForm';

export const ImportUsersForm = () => {
  const closeModal = () => {};
  const { handleFileInput, submitUpload, file } = useUserUploadForm({
    campaingId: null,
    closeModal,
    isSegment: false,
  });
  const { t } = useTranslation('users');

  const uploadFile = async e => {
    try {
      await submitUpload(e);
    } finally {
      window.location.reload();
    }
  };

  return (
    <form>
      <FileInput
        id={'file'}
        name={'file'}
        fileTypes={'.csv,.xlsx'}
        fileName={file.name}
        onChange={handleFileInput}
      />
      <StyledDivButton>
        <SubmitButton
          type="submit"
          value={t('importUsersForm.uploadFile')}
          name="commit"
          id="file-upload-submit"
          disabled={!file.name}
          onClick={uploadFile}
        />
      </StyledDivButton>
    </form>
  );
};
